import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const BillDataModal = ({ show, onHide, billData, onPayNow }) => {
  const [amount, setAmount] = useState("");

  if (!billData) return null;

  const handlePayNow = () => {
    const payAmount = billData.accept_part_pay
      ? amount
      : billData.bill_net_amount;
    if (!payAmount || isNaN(payAmount)) return alert("Enter valid amount");
    onPayNow(payAmount);
  };

  return (
    <Modal show={show} onHide={onHide} centered className="border-0">
      <Modal.Header className="bg-primary text-white d-flex justify-content-between align-items-center">
        <Button
          variant="link"
          className="text-white text-decoration-none"
          onClick={onHide}
        >
          &larr; Close
        </Button>
        <Modal.Title className="text-white m-0">Bill Details</Modal.Title>
      </Modal.Header>

      <Modal.Body className="bg-light">
        <div className="mb-2">
          <strong>Customer Name:</strong> {billData.customer_name || "N/A"}
        </div>
        <div className="mb-2">
          <strong>Customer Ref ID:</strong> {billData.customer_ref_id}
        </div>
        {billData.bill_date && (
          <div className="mb-2">
            <strong>Bill Date:</strong> {billData.bill_date}
          </div>
        )}

        {billData.due_date && (
          <div className="mb-2">
            <strong>Due Date:</strong> {billData.due_date}
          </div>
        )}

        <div className="mb-2">
          <strong>Bill Amount:</strong> ₹{billData.bill_amount}
        </div>
        <div className="mb-2">
          <strong>Net Amount:</strong> ₹{billData.bill_net_amount}
        </div>
        {/* <div className="mb-3">
          <strong>Payment Allowed:</strong>{" "}
          {billData.accept_payment ? "Yes" : "No"} |
          <strong> Partial Payment:</strong>{" "}
          {billData.accept_part_pay ? "Yes" : "No"}
        </div> */}

        {billData.accept_part_pay && (
          <Form.Group controlId="partialAmount">
            <Form.Label>Enter Amount to Pay</Form.Label>
            <Form.Control
              type="number"
              placeholder="Enter amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              min={1}
            />
          </Form.Group>
        )}
      </Modal.Body>

      <Modal.Footer className="bg-white">
        <div className="d-flex justify-content-between w-100">
          <Button variant="outline-secondary" onClick={onHide}>
            Close
          </Button>
          <Button variant="primary" onClick={handlePayNow}>
            Pay Now
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default BillDataModal;
